import React, { useEffect, useCallback } from 'react';
import * as Styles from './UpgradePlan.styles';

import useLocale from '@/hooks/useLocale';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

import { IconArrow, Skeleton } from 'gatorcomponents';

import UpgradeListing from './components/UpgradeListing/UpgradeListing';
import UpgradeDetails from './components/UpgradeDetails/UpgradeDetails';

import { VPS_OCI_PAGE_STEPS } from '@/pages/Products/VpsOciDetailPage/VpsOciDetailPage.enum';

const UpgradePlan = ({
  currentStep,
  onNavigateToStep,
}) => {
  const dispatch = useDispatch();
  const { id: hostingId } = useParams();

  const { upgradeListingLoading, upgradeDetailsData } = useSelector(state => ({
    upgradeListingLoading: state.vpsOci?.upgrade?.listing?.loading,
    upgradeDetailsData: state.vpsOci?.upgrade?.details?.data,
  }), shallowEqual);

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: vpsOciLocale } = productDetailsLocale;
  const upgradeLocale = vpsOciLocale && vpsOciLocale.planDetails && vpsOciLocale.planDetails.upgrade;
  const {
    backButton: backButtonLabel,
  } = upgradeLocale || {};

  const handleSelectPlan = (plan) => {
    const { billingCycle, productId } = plan;
    if (!productId || !billingCycle) return;
    dispatch(vpsOciActions.upgrade.details.request({
      hostingId,
      productId,
      billingCycle,
      coupon: null,
    }));
  };

  const handleBackButtonClick = useCallback(() => {
    if (currentStep === VPS_OCI_PAGE_STEPS.UPGRADE_DETAILS) {
      onNavigateToStep(VPS_OCI_PAGE_STEPS.UPGRADE_LISTING);
    } else if (currentStep === VPS_OCI_PAGE_STEPS.UPGRADE_LISTING) {
      onNavigateToStep(VPS_OCI_PAGE_STEPS.DETAILS);
    }
  }, [currentStep, onNavigateToStep]);

  useEffect(() => {
    if (upgradeDetailsData && Object.keys(upgradeDetailsData).length > 0) {
      onNavigateToStep(VPS_OCI_PAGE_STEPS.UPGRADE_DETAILS);
    }
  }, [upgradeDetailsData, onNavigateToStep]);

  if (upgradeListingLoading) {
    return (
      <Styles.Container data-testid="vpsoci-upgrade-page-loading">
        <Skeleton width="100%" height="116px" />
        <Skeleton width="100%" height="600px" />
      </Styles.Container>
    );
  }

  return (
    <Styles.Container data-testid="vpsoci-upgrade-page">
      <Styles.BackButton onClick={() => handleBackButtonClick()} data-testid="vpsoci-upgrade-page-back-button">
        <IconArrow
          size="md"
          color="primaryMedium"
          testId="vpsoci-upgrade-page-back-button-icon"
          direction="left"
        />
        <Styles.BackButtonLabel>{backButtonLabel}</Styles.BackButtonLabel>
      </Styles.BackButton>
      <Styles.Content>
        {currentStep === VPS_OCI_PAGE_STEPS.UPGRADE_DETAILS && <UpgradeDetails onBackButtonClick={handleBackButtonClick} />}
        {currentStep === VPS_OCI_PAGE_STEPS.UPGRADE_LISTING && <UpgradeListing onSelectPlan={handleSelectPlan} />}
      </Styles.Content>
    </Styles.Container>
  );
};

export default UpgradePlan;
